webpackJsonp([22620996268344],{

/***/ 452:
/***/ (function(module, exports) {

	module.exports = {"data":{"markdownRemark":{"html":"<p>If you're looking forward to what Laravel 5.3 has to offer then I would definitely recommend that you watch this video of Taylor Otwell which goes into detail on what the latest version has to offer. It is pretty long at 1 hour and 36 minutes, but my gosh is it worth it.</p>\n<p><a href=\"https://streamacon.com/video/laracon-us/taylor-otwell-laravel-53-overview\">https://streamacon.com/video/laracon-us/taylor-otwell-laravel-53-overview</a></p>","frontmatter":{"categories":["General Updates","Laravel"],"date":"August 03, 2016","featuredImage":"placeholder.png","title":"Watch Taylor Otwell - Laravel 5.3 Overview from Laracon US!"}}},"pathContext":{"slug":"/watch-taylor-otwell-laravel-53-overview-laracon-us/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---post-watch-taylor-otwell-laravel-53-overview-laracon-us-a038d75ab493c0b915a4.js